/**
 * Campaign state for box 5's status column and the Active filter (spec §4,
 * ruling R26). The end date is read first, so a campaign the platform still
 * calls active or paused reads "จบ <date>" once its end date is before
 * yesterday (Bangkok, passed in by the caller). Pure.
 *
 * @module services/channels/campaignState
 */
import type { CampaignState, ChannelEntity } from './channelTypes';

/** R26, in its order. Plain ISO dates compare as strings. */
export const campaignStateOf = (
  e: Pick<ChannelEntity, 'campaignStatus' | 'campaignEndDate'>,
  yesterday: string,
): CampaignState => {
  if (e.campaignEndDate !== null && e.campaignEndDate < yesterday) return { kind: 'ended', endDate: e.campaignEndDate };
  if (e.campaignStatus === 'completed' || e.campaignStatus === 'archived') return { kind: 'ended', endDate: null };
  if (e.campaignStatus === 'paused') return { kind: 'paused' };
  if (e.campaignStatus === 'active') return { kind: 'active' };
  return { kind: 'unknown' };
};

/** Active is the `active` state only: paused, ended and unknown never count as Active (spec §4). */
export const isActiveState = (s: CampaignState): boolean => s.kind === 'active';
